export class LoginModel {
    email: string;
    password: string;

    constructor(){
        this.email = '';
        this.password = '';
    }
}